import type { ComponentType } from 'react';
import {
	FullBodyHold,
	FullBodyElevation,
	FullBodyGrip3,
	FullBodyGrip4,
	FullBodyUnderhandGrip,
	FullBodyLowering5,
	FullBodyLowering6,
	FullBodyKnelling2,
	FullBodyKnelling1,
	FullBodyKnelling3
} from '@/assets/svg/human_body';
import { KIM_LHC_BODY_POSTURE } from '@/components/views/Report/KimLhc/Constants';

export interface PostureImageConfig {
	component: ComponentType;
	key: string;
}

export interface PostureOption {
	id: string;
	value: number;
	startLabel: string;
	endLabel: string;
	startImages: PostureImageConfig[];
	endImages: PostureImageConfig[];
}

export const POSTURE_OPTIONS: PostureOption[] = [
	{
		id: 'option_1',
		value: KIM_LHC_BODY_POSTURE.option_1,
		startLabel: 'Start/End',
		endLabel: 'End/Start',
		startImages: [{ component: FullBodyHold, key: '1' }],
		endImages: [{ component: FullBodyHold, key: '2' }]
	},
	{
		id: 'option_2',
		value: KIM_LHC_BODY_POSTURE.option_2,
		startLabel: 'Start/End',
		endLabel: 'End/Start',
		startImages: [{ component: FullBodyHold, key: '1' }],
		endImages: [
			{ component: FullBodyGrip3, key: '2' },
			{ component: FullBodyGrip4, key: '3' },
			{ component: FullBodyElevation, key: '4' },
			{ component: FullBodyUnderhandGrip, key: '5' }
		]
	},
	{
		id: 'option_3',
		value: KIM_LHC_BODY_POSTURE.option_3,
		startLabel: 'Start/End',
		endLabel: 'End/Start',
		startImages: [
			{ component: FullBodyGrip3, key: '1' },
			{ component: FullBodyGrip4, key: '2' },
			{ component: FullBodyElevation, key: '3' },
			{ component: FullBodyUnderhandGrip, key: '4' }
		],
		endImages: [
			{ component: FullBodyGrip3, key: '5' },
			{ component: FullBodyGrip4, key: '6' },
			{ component: FullBodyElevation, key: '7' },
			{ component: FullBodyUnderhandGrip, key: '8' }
		]
	},
	{
		id: 'option_4',
		value: KIM_LHC_BODY_POSTURE.option_4,
		startLabel: 'Start/End',
		endLabel: 'End/Start',
		startImages: [{ component: FullBodyHold, key: '1' }],
		endImages: [
			{ component: FullBodyLowering5, key: '2' },
			{ component: FullBodyLowering6, key: '3' }
		]
	},
	{
		id: 'option_5',
		value: KIM_LHC_BODY_POSTURE.option_5,
		startLabel: 'Start/End',
		endLabel: 'End/Start',
		startImages: [{ component: FullBodyHold, key: '1' }],
		endImages: [
			{ component: FullBodyKnelling1, key: '2' },
			{ component: FullBodyKnelling2, key: '3' },
			{ component: FullBodyKnelling3, key: '4' }
		]
	},
	{
		id: 'option_6',
		value: KIM_LHC_BODY_POSTURE.option_6,
		startLabel: 'Start/End',
		endLabel: 'End/Start',
		startImages: [
			{ component: FullBodyGrip3, key: '1' },
			{ component: FullBodyGrip4, key: '2' },
			{ component: FullBodyElevation, key: '3' },
			{ component: FullBodyUnderhandGrip, key: '4' }
		],
		endImages: [
			{ component: FullBodyLowering5, key: '5' },
			{ component: FullBodyLowering6, key: '6' }
		]
	},
	{
		id: 'option_7',
		value: KIM_LHC_BODY_POSTURE.option_7,
		startLabel: 'Start/End',
		endLabel: 'End/Start',
		startImages: [
			{ component: FullBodyGrip3, key: '1' },
			{ component: FullBodyGrip4, key: '2' },
			{ component: FullBodyElevation, key: '3' },
			{ component: FullBodyUnderhandGrip, key: '4' }
		],
		endImages: [
			{ component: FullBodyKnelling1, key: '5' },
			{ component: FullBodyKnelling2, key: '6' },
			{ component: FullBodyKnelling3, key: '7' }
		]
	},
	{
		id: 'option_8',
		value: KIM_LHC_BODY_POSTURE.option_8,
		startLabel: 'Start/End',
		endLabel: 'End/Start',
		startImages: [
			{ component: FullBodyLowering5, key: '1' },
			{ component: FullBodyLowering6, key: '2' }
		],
		endImages: [
			{ component: FullBodyLowering5, key: '3' },
			{ component: FullBodyLowering6, key: '4' }
		]
	},
	{
		id: 'option_9',
		value: KIM_LHC_BODY_POSTURE.option_9,
		startLabel: 'Start/End',
		endLabel: 'End/Start',
		startImages: [
			{ component: FullBodyLowering5, key: '1' },
			{ component: FullBodyLowering6, key: '2' }
		],
		endImages: [
			{ component: FullBodyKnelling1, key: '3' },
			{ component: FullBodyKnelling2, key: '4' },
			{ component: FullBodyKnelling3, key: '5' }
		]
	},
	{
		id: 'option_10',
		value: KIM_LHC_BODY_POSTURE.option_10,
		startLabel: 'Start/End',
		endLabel: 'End/Start',
		startImages: [
			{ component: FullBodyKnelling1, key: '1' },
			{ component: FullBodyKnelling2, key: '2' },
			{ component: FullBodyKnelling3, key: '3' }
		],
		endImages: [
			{ component: FullBodyKnelling1, key: '4' },
			{ component: FullBodyKnelling2, key: '5' },
			{ component: FullBodyKnelling3, key: '6' }
		]
	}
];
